import { render, staticRenderFns } from "./DeveloperList.vue?vue&type=template&id=d2cf60e0&scoped=true&"
import script from "./DeveloperList.vue?vue&type=script&lang=js&"
export * from "./DeveloperList.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperList.vue?vue&type=style&index=0&id=d2cf60e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cf60e0",
  null
  
)

export default component.exports